import React from 'react'

const IconRemove = ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="M378.12-317.89 480.5-420.27l102.38 102.38 39.73-39.73L520.23-460l102.38-102.38-39.73-39.73L480.5-499.73 378.12-602.11l-39.73 39.73L440.77-460 338.39-357.62l39.73 39.73Zm-83.39 169.81q-28.44 0-48.35-19.91-19.92-19.92-19.92-48.27v-501.32h-39.19v-55.89h174.35v-33.84h237.57v33.77h174.35v55.96h-39.2v501.32q0 28.35-19.91 48.27-19.92 19.91-48.35 19.91H294.73Zm383.65-569.5H282.42v501.23q0 4.62 3.85 8.47 3.85 3.84 8.46 3.84h371.35q4.61 0 8.46-3.84 3.84-3.85 3.84-8.47v-501.23Zm-395.96 0V-204.04v-513.54Z"/>
   </svg>
  )
}
export default IconRemove 